export function updateLibraryState(state, payload) {
  state[payload.state] = payload.data;
}
